import { getUrlParameters } from "@/utils/url";

export const SHARED_DATA_ENDPOINT = "/invite_code";

export async function setInviteCode() {
  const queryObject = getUrlParameters();
  let code;
  if (queryObject.code) {
    code = queryObject.code;
  }
  await fetch(SHARED_DATA_ENDPOINT, {
    method: "POST",
    body: JSON.stringify({ code })
  });
}

export async function getInviteCode() {
  try {
    const response = await fetch(SHARED_DATA_ENDPOINT);
    const data = await response.json();
    const { code } = data;
    if (code) {
      return code;
    }
    return undefined;
  } catch (e) {
    return undefined;
  }
}
